import { render, staticRenderFns } from "./CandidatesProcessedPage.vue?vue&type=template&id=57c424cc&scoped=true&lang=pug"
import script from "./CandidatesProcessedPage.vue?vue&type=script&lang=js"
export * from "./CandidatesProcessedPage.vue?vue&type=script&lang=js"
import style0 from "./CandidatesProcessedPage.vue?vue&type=style&index=0&id=57c424cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c424cc",
  null
  
)

export default component.exports